export default function (componentName) {
  return {
    data () {
      return {
        visible: false
      }
    },
    mounted () {
      this.$bus.on('ui/notification', ({ name, action } = {}) => {
        if ((!action || action === 'open') && name === componentName) {
          this.visible = true
        }
      })

      this.$bus.on('ui/notification', ({ name, action } = {}) => {
        if (action === 'close' && (name === componentName || name === '*')) {
          this.visible = false
        }
      })
    }
  }
}